import { ArchivedFilter } from "@avenueops/shared-types";
import SignalsPage from "components/signals/SignalsPage";
import React from "react";

export default function Signals(): JSX.Element {
  return <SignalsPage archived={ArchivedFilter.enum.UNARCHIVED} />;
}
